export default __webpack_public_path__ + "static/media/MenudsjinscampWestMap.3c93b74e.jpg";